import React from 'react';
import { AutocompleteRenderOptionState, Chip, Box, Typography } from '@mui/material';
import StoreOutlined from '@mui/icons-material/StoreOutlined';

import { gray5, lightGray, white } from 'utils/color-styles';
import Img from 'retired/Img';
import { renderAddress } from 'utils/renderAddress';
import Organization from 'entities/organization/model';
import { OrganizationLabel } from 'components/OrganizationLabel/OrganizationLabel';

const OrganizationIcon = (
  <div
    style={{
      width: 40,
      height: 40,
      borderRadius: 20,
      background: gray5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <StoreOutlined sx={{ fontSize: 24 }} htmlColor={white} />
  </div>
);

export const renderOption: (
  props: React.HTMLAttributes<HTMLLIElement>,
  option: Partial<Organization>,
  state: AutocompleteRenderOptionState & { isUserAdmin: boolean }
) => React.ReactNode = (props, option, { isUserAdmin = false }) => (
  <li {...props} style={{ ...props.style, paddingBottom: 0 }}>
    <Box display="flex" width="100%">
      <Box mr={2} width={40}>
        {option.mainPicture ? <Img width={40} src={option.mainPicture} /> : OrganizationIcon}
      </Box>
      <Box flexGrow={1} borderBottom={`1px solid ${lightGray}`} pb={1}>
        <Typography component="p" mt={0.5} mb={0.5} style={{ fontSize: 14 }}>
          {option.name}
        </Typography>
        {isUserAdmin && option.invisible && (
          <Chip
            style={{
              marginBottom: 8,
              borderRadius: 16,
              background: gray5,
            }}
            label="INVISIBLE IN SEARCH"
          />
        )}
        {isUserAdmin && option.deletedAt && (
          <Chip
            style={{
              marginBottom: 8,
              marginLeft: 8,
              marginRight: 8,
              borderRadius: 16,
              background: gray5,
            }}
            label="DELETED"
          />
        )}
        <OrganizationLabel organization={option} />{' '}
        {option.ein && (
          <Typography component="p" style={{ fontSize: 12 }}>
            EIN: {option.ein}
          </Typography>
        )}
        <Typography component="p" color="GrayText" style={{ fontSize: 12 }}>
          {renderAddress(option.locationObject)}
        </Typography>
      </Box>
    </Box>
  </li>
);
